import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

/**
 * Extends dayjs with required plugins
 */
export const extendDayjs = () => {
  dayjs.extend(isSameOrAfter);
  dayjs.extend(isSameOrBefore);
};

import type { Dayjs } from "dayjs";
import type { ReactNode } from "react";
export interface DatePreset {
  label: string;
  value: [Dayjs, Dayjs];
  icon?: ReactNode;
}